import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function CurriculumQaLabels({ question, legacyOutcomes = [] }) {
  const math = Boolean(question?.outcome_label);
  const outcomes = math ? question.outcomes || [] : legacyOutcomes;
  const text = outcomes.map((item) => `${item.code}${math
    ? ` — ${item.title_verified && item.official_title ? item.official_title : 'Resmî ad doğrulanmadı'}`
    : item.text ? ` — ${item.text}` : ''}`).join(' · ');
  return <Box sx={{ flex: 1, minWidth: 0 }}>
    {outcomes.length > 0 && <>
      <Typography sx={{ color: 'text.secondary', fontSize: 11, fontWeight: 800 }}>{math ? question.outcome_label : 'İlişkili kazanım'}</Typography>
      <Typography title={text} sx={{ fontSize: { xs: 12, sm: 14 }, fontWeight: 700, lineHeight: 1.25,
        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{text}</Typography>
    </>}
    {math && <>
      <Typography sx={{ fontSize: 12, mt: 0.5 }}><strong>Level odağı:</strong> {question.level_focus || 'Odak eşlemesi bulunamadı'}</Typography>
      {question.question_focus && question.question_focus !== question.level_focus && <Typography sx={{ fontSize: 11, color: 'text.secondary' }}><strong>Soru odağı:</strong> {question.question_focus}</Typography>}
      {question.metadata_status && question.metadata_status !== 'ok' && <Typography sx={{ fontSize: 11, color: 'error.main' }}>Level–kazanım eşlemesi kontrol edilmeli.</Typography>}
    </>}
  </Box>;
}
